import React, { useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional for styling
import "tippy.js/themes/light.css"; // optional for light theme
import Select from "react-select";
import { GoFilter } from "react-icons/go";

const FilterComponent = ({ facets, onFilterChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  // Convert facets into grouped options
  const groupedOptions = facets.map((facet) => ({
    label: facet.expression,
    options: facet.data.map((item) => ({
      label: `${Object.values(item)[0]} (${item.count})`,
      value: `${facet.expression}:${Object.values(item)[0]}`,
    })),
  }));

  const handleSelectionChange = (selected) => {
    setSelectedOptions(selected);

    // If no filters are selected, reset the data to its initial state
    const filters = selected.length
      ? selected.reduce((acc, opt) => {
          const [key, value] = opt.value.split(":");
          acc[key] = acc[key] ? `${acc[key]}, ${value}` : value;
          return acc;
        }, {})
      : {}; // Empty filter if nothing is selected

    onFilterChange(filters); // Send filter object to Dashboard
  };

  const handleToggleTooltip = () => {
    setIsTooltipVisible(!isTooltipVisible);
  };

  return (
    <div>
      <button
        onClick={handleToggleTooltip}
        className="btn btn-outline-primary me-3"
      >
        Filters <GoFilter />
      </button>

      {isTooltipVisible && (
        <Tippy
          content={
            <Select
              options={groupedOptions}
              isMulti
              value={selectedOptions}
              onChange={handleSelectionChange}
              closeMenuOnSelect={false}
              placeholder="Select filters"
              menuPosition="absolute"
              menuPlacement="auto"
              styles={{
                menuPosition: (base) => ({ ...base, zIndex: 9999 }), // Ensure it's on top
                menu: (base) => ({
                  ...base,
                  whiteSpace: "nowrap", // Prevents wrapping of individual options
                  overflowX: "hidden", // Hides any x-scroll
                  width: "265px", // Allows content to grow without forcing horizontal scroll
                  minWidth: "150px", // Set a reasonable minimum width
                }),
                menuList: (base) => ({
                  ...base,
                  maxHeight: "350px",
                  minWidth: "150px",
                }),
              }}
            />
          }
          interactive={true}
          theme="light"
          visible={isTooltipVisible}
          onClickOutside={handleToggleTooltip}
          appendTo={document.body}
          placement="bottom"
          className="me-4"
        >
          <span></span>
        </Tippy>
      )}
    </div>
  );
};

export default FilterComponent;
